<div class="pt-4 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage this inbox.</h2>
</div>

<div class="pt-4 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-4 pl-md-4">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Documents Pending Staff Approval
        <span *ngIf="inboxService.getInboxCounts() && inboxService.getInboxCounts().documents_pending_staff_approval">
          ({{ inboxService.getInboxCounts().documents_pending_staff_approval }})
        </span>
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Completion Date</th>
        <th scope="col">Customer Name</th>
        <th scope="col">Document Name</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingActiveDocuments && activeDocumentsPresent()">
      <tr *ngFor="let document of activeDocuments">
        <td>
          {{ timeStringFromISO8601(document.document_completed_at) }},
          {{ dateStringFromISO8601(document.document_completed_at) }}
        </td>
        <td>
          <ng-container *ngFor="let relatedCustomer of document.related_customers; let last = last;">
            <a [routerLink]="['/customers', relatedCustomer.id.toString()]" target="_blank">
              {{ relatedCustomer.first_name }} {{ relatedCustomer.last_name }}
            </a>
            <br *ngIf="!last">
          </ng-container>
        </td>
        <td>{{ document.document_name }}</td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openReviewActiveDocumentModal(document);$event.preventDefault();">
            Review
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingActiveDocuments || !activeDocumentsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingActiveDocuments">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingActiveDocuments">
          No documents pending staff approval.
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="text-right">
    <nav aria-label="Pagination">
      <ul class="pagination justify-content-end mb-0">
        <li class="page-item" [class.disabled]="activeDocsPageNum <= 1">
          <button class="page-link" aria-label="Previous" [disabled]="activeDocsPageNum <= 1"
             (click)="setActiveDocsPage(activeDocsPageNum - 1)">
            <span aria-hidden="true">&laquo;</span>
          </button>
        </li>
        <li class="page-item" *ngIf="activeDocsPageNum > 2">
          <button class="page-link" (click)="setActiveDocsPage(activeDocsPageNum - 2)">
            {{ activeDocsPageNum - 2 }}
          </button>
        </li>
        <li class="page-item" *ngIf="activeDocsPageNum > 1">
          <button class="page-link" (click)="setActiveDocsPage(activeDocsPageNum - 1)">
            {{ activeDocsPageNum - 1 }}
          </button>
        </li>
        <li class="page-item active" aria-current="page">
          <button class="page-link" disabled>
            {{ activeDocsPageNum }}
            <span class="sr-only">(current)</span>
          </button>
        </li>
        <li class="page-item" *ngIf="activeDocsPageNum < lastPageNumber()">
          <button class="page-link" (click)="setActiveDocsPage(activeDocsPageNum + 1)">
            {{ activeDocsPageNum + 1 }}
          </button>
        </li>
        <li class="page-item" *ngIf="activeDocsPageNum < (lastPageNumber() - 1)">
          <button class="page-link" (click)="setActiveDocsPage(activeDocsPageNum + 2)">
            {{ activeDocsPageNum + 2 }}
          </button>
        </li>
        <li class="page-item" [class.disabled]="activeDocsPageNum >= lastPageNumber()">
          <button class="page-link" aria-label="Next" [disabled]="activeDocsPageNum >= lastPageNumber()"
             (click)="setActiveDocsPage(activeDocsPageNum + 1)">
            <span aria-hidden="true">&raquo;</span>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</div>

<div class="pt-3 pl-md-4 mb-6">
  <div class="row">
    <div class="col">
      <p class="text-center w-100"><b>
        Recently Updated
      </b></p>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table">

      <thead>
      <tr>
        <th scope="col">Status</th>
        <th scope="col">Updated Date</th>
        <th scope="col">Customer Name</th>
        <th scope="col">Document Name</th>
        <th scope="col"></th>
      </tr>
      </thead>

      <tbody *ngIf="!loadingDismissedDocuments && dismissedDocumentsPresent()">
      <tr *ngFor="let document of dismissedDocuments">
        <td>
          {{ document.resolved_by_id ? 'Resolved' : 'Dismissed' }}
        </td>
        <td>
          <ng-container *ngIf="document.resolved_by_id">
            {{ timeStringFromISO8601(document.resolved_at) }},
            {{ dateStringFromISO8601(document.resolved_at) }}
          </ng-container>
          <ng-container *ngIf="!document.resolved_by_id">
            {{ timeStringFromISO8601(document.dismissed_at) }},
            {{ dateStringFromISO8601(document.dismissed_at) }}
          </ng-container>
        </td>
        <td>
          <ng-container *ngFor="let relatedCustomer of document.related_customers; let last = last;">
            <a [routerLink]="['/customers', relatedCustomer.id.toString()]" target="_blank">
              {{ relatedCustomer.first_name }} {{ relatedCustomer.last_name }}
            </a>
            <br *ngIf="!last">
          </ng-container>
        </td>
        <td>{{ document.document_name }}</td>
        <td class="table-btn-sm text-right">
          <button class="btn btn-outline-primary btn-sm" style="min-width: 120px"
                  (click)="openViewDismissedDocumentModal(document);$event.preventDefault();">
            View
          </button>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="loadingDismissedDocuments || !dismissedDocumentsPresent()">
      <tr>
        <td colspan="99" *ngIf="loadingDismissedDocuments">
          Loading...
        </td>
        <td colspan="99" *ngIf="!loadingDismissedDocuments && !dismissedDocumentsPresent()">
          No dismissed or resolved documents pending staff approval.
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <p class="text-muted">
    This table displays the 20 most recently updated Documents Pending Approval inbox items.
  </p>
</div>
